export default {
  errors: null,
  products: [],
  loading: false,
  count: 0,
  totalCount: 0,
  filterValues: []
};
